<!-- DDCFB -->
<div>
  <ngc-switching-account
    [bannerDetails]="contentInterstitialBanner"
    [isDesktop]="deviceTypes.isDesktop"
  ></ngc-switching-account>
</div>
